// DivisionWinnerBanner.jsx
import React from "react";


function DivisionWinnerBanner({ bracketData, games }) {
  if (!bracketData) return null;
  const finalRound = bracketData.rounds.at(-1);
  const finalMatch = finalRound?.[0];
  const finalGame = games.find(
    (g) =>
      g.home_team_id === finalMatch?.teamA?.slt_id &&
      g.away_team_id === finalMatch?.teamB?.slt_id &&
      g.score_home != null &&
      g.score_away != null &&
      g.score_home !== g.score_away
  );
  if (!finalGame) return null;

  const isHomeWinner = finalGame.score_home > finalGame.score_away;
  const winner =
    finalGame.home_team_id === finalMatch.teamA?.slt_id
      ? (isHomeWinner ? finalMatch.teamA : finalMatch.teamB)
      : (isHomeWinner ? finalMatch.teamB : finalMatch.teamA);

  return (
    <div style={{
      marginTop: '2rem',
      padding: '1rem',
      backgroundColor: '#f7f7f7',
      border: '2px solid gold',
      borderRadius: '10px',
      fontWeight: 'bold',
      textAlign: 'center',
      fontSize: '1.25rem'
    }}>
      🏆 Congratulations {winner?.name} — Division Champion!
    </div>
  );
}
export default DivisionWinnerBanner;
